
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/data-display.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-data-display-demo-mermaid","docs-x-markdown-data-display-demo-infographic"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/data-display.en-US.md?type=demo')
};